// extracted by mini-css-extract-plugin
module.exports = {"container":"Link_container__2Xe_Q","message":"Link_message__C-C61","link":"Link_link__20VTU"};